"use client";
import { type ReactNode, useCallback, useSyncExternalStore } from "react";
import { getActiveCampaigns, type CampaignConfig } from "@/lib/campaigns/promotions/config";
export function CampaignAnnouncementExpiry({
	children,
	campaign,
	channel,
}: {
	children: ReactNode;
	campaign: CampaignConfig;
	channel?: string;
}) {
	const subscribe = useCallback(
		(onChange: () => void) => {
			let timer: ReturnType<typeof setTimeout>;
			const check = () => {
				clearTimeout(timer);
				onChange();
				const now = Date.now();
				const boundary =
					now < Date.parse(campaign.startsAt)
						? Date.parse(campaign.startsAt)
						: Date.parse(campaign.endsAt) + 1;
				if (boundary > now) timer = setTimeout(check, Math.min(boundary - now, 60_000));
			};
			check();
			document.addEventListener("visibilitychange", check);
			window.addEventListener("focus", check);
			window.addEventListener("pageshow", check);
			return () => {
				clearTimeout(timer);
				document.removeEventListener("visibilitychange", check);
				window.removeEventListener("focus", check);
				window.removeEventListener("pageshow", check);
			};
		},
		[campaign],
	);
	const active = useSyncExternalStore(
		subscribe,
		() => getActiveCampaigns(new Date(), channel, [campaign]).length > 0,
		() => true,
	);
	return active ? children : null;
}
